// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js!./mordern-normalize.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../../node_modules/css-loader/dist/cjs.js!./fonts.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../../node_modules/css-loader/dist/cjs.js!./common.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: 'Noto Sans KR', sans-serif;
}

a, a:hover, a:active, a:focus {
  color: inherit;
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/styles/common/index.css"],"names":[],"mappings":"AAIA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB","sourcesContent":["@import './mordern-normalize.css';\n@import './fonts.css';\n@import './common.css';\n\nbody {\n  font-family: 'Noto Sans KR', sans-serif;\n}\n\na, a:hover, a:active, a:focus {\n  color: inherit;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
